import { Injectable } from '@angular/core';
import * as bundleimagepath from './bundleimages.json';
import * as trailerimagepath from './trailerimages.json';

interface typImage {
  name: string;
  oImage: HTMLImageElement;
}

@Injectable({
  providedIn: 'root',
})
export class TypimagesService {
  private loadedImages = new Array<typImage>();
  constructor() {}

  public loadBundleImages() {
    //console.log(bundleimagepath.elements);
    for (let data of bundleimagepath.elements) {
      const img = new Image();
      img.addEventListener(
        'load',
        () => {
          this.loadedImages.push({ name: data.name, oImage: img });
        },
        false
      );
      img.src = data.path;
    }
  }

  public loadTrailerImages() {
    for (let data of trailerimagepath.elements) {
      const img = new Image();
      img.addEventListener(
        'load',
        () => {
          this.loadedImages.push({ name: data.name, oImage: img });
        },
        false
      );
      img.src = data.path;
    }
  }

  public getImage(imageName : string){
    return this.loadedImages.find((element) => element.name === imageName);
  }
}
